












import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ErrorComponent extends Vue {
    title: string = 'Unhandled error';
    message: string = 'An unhandled error has occured!';
    error: any;

    created() {
        // reload to the loging page
        const { message, error, title } = this.$route.params;
        if (title) this.title = title;
        if (message) this.message = message;
        if (error) this.error = error;
    }

    reset() {
        window.localStorage.clear();
        location.reload();
    }
}
